import { current } from '@reduxjs/toolkit';
import React from 'react';
import { useSelector } from 'react-redux';
import Loading from '../../Components/UiLoadingComponents/Loading';
import { useGetAllPublishedAssignmentMarkQuery } from '../../features/assignmentMark/assignmentMarkApi';
import { useGetAllUserQuery } from '../../features/auth/authApi';
import { selectUser } from '../../features/auth/selector';
import { useGetAllQuizMarkQuery } from '../../features/quizMark/quizMarkApi';
import getLeaderBoardPlacement from '../../utilities/leaderBoardPlacement';

const LeaderBoard = () => {
    const { user } = useSelector(selectUser)
    const { data: allUsers, isLoading: isAllUsersLoading, isError: isAllUserError } = useGetAllUserQuery()
    const { data: allQuizMark, isLoading: isAllQuizMarkLoading, isError: isAllQuizMarkError, } = useGetAllQuizMarkQuery()
    const { data: allAssignmentMark, isLoading: isAllAssignmentMarkLoading, isError: isAllAssignmentMarkError } = useGetAllPublishedAssignmentMarkQuery()


    let content = null;
    if (isAllAssignmentMarkLoading || isAllQuizMarkLoading || isAllUsersLoading) {
        content = <div>
            <Loading className='center-of-window'></Loading>
        </div>

    }
    else if (!isAllUserError && !isAllQuizMarkError && !isAllAssignmentMarkError) {

        const { placements, ownUserPlacement } = getLeaderBoardPlacement({ allUsers, allQuizMark, allAssignmentMark, user })


        content = <section className="py-6 bg-primary">
            <div className="mx-auto max-w-7xl px-5 lg:px-0">
                <div>

                    {
                        ownUserPlacement?.id ? <>
                            <h3 className="text-lg font-bold">Your Position in Leaderboard</h3>
                            <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
                                <thead>
                                    <tr>
                                        <th className="table-th !text-center">Rank</th>
                                        <th className="table-th !text-center">Name</th>
                                        <th className="table-th !text-center">Quiz Mark</th>
                                        <th className="table-th !text-center">Assignment Mark</th>
                                        <th className="table-th !text-center">Total</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr className="border-2 border-cyan">
                                        <td className="table-td text-center font-bold">{ownUserPlacement.placement}</td>
                                        <td className="table-td text-center font-bold">{ownUserPlacement.name}</td>
                                        <td className="table-td text-center font-bold">{ownUserPlacement.quizMark}</td>
                                        <td className="table-td text-center font-bold">{ownUserPlacement.assignmentMark}</td>
                                        <td className="table-td text-center font-bold">{ownUserPlacement.total}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </> : <div>

                        </div>
                    }
                </div>

                <div className="my-8">
                    <h3 className="text-lg font-bold">Top 20 Result</h3>
                    <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
                        <thead>
                            <tr className="border-b border-slate-600/50">
                                <th className="table-th !text-center">Rank</th>
                                <th className="table-th !text-center">Name</th>
                                <th className="table-th !text-center">Quiz Mark</th>
                                <th className="table-th !text-center">Assignment Mark</th>
                                <th className="table-th !text-center">Total</th>
                            </tr>
                        </thead>

                        <tbody>

                            {
                                placements?.map(single => <tr key={single.id} className="border-b border-slate-600/50">
                                    <td className="table-td text-center">{single.placement}</td>
                                    <td className="table-td text-center">{single.name}</td>
                                    <td className="table-td text-center">{single.quizMark}</td>
                                    <td className="table-td text-center">{single.assignmentMark}</td>
                                    <td className="table-td text-center">{single.total}</td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    }
    return (
        <>
            {content}
        </>

    );
};

export default LeaderBoard;